import { Component, OnInit } from "@angular/core";
import { NgxSpinnerService } from "ngx-spinner";
import { TranslateService } from "@ngx-translate/core";
import { LanguageService } from "src/app/shared/services/language.service";
import { Language } from "src/app/landing-pages/thi/thi-translations";
import { normalizeThiLang } from "src/app/landing-pages/thi/thi-lang.util";

interface LanguageSetting {
	language: string;
	code: 'en' | 'ar' | 'he';
	icon: string;
}

@Component({
	selector: "app-privacy-policy",
	templateUrl: "./privacy-policy.component.html",
	styleUrls: ["./privacy-policy.component.scss"]
})

export class PrivacyPolicyComponent implements OnInit {
	curentLang: string = "";
	landingLang: Language = "ar";
	
	public languages: LanguageSetting[] = [
		{ language: 'English', code: 'en', icon: '🇺🇸' },
		{ language: 'Arabic', code: 'ar', icon: '🇸🇦' },
		{ language: 'Hebrew', code: 'he', icon: '🇮🇱' }
	];
	
	public selectedLanguage: LanguageSetting = this.languages[0];

	constructor(
		private spinner: NgxSpinnerService,
		private translate: TranslateService,
		private languageService: LanguageService,
	) {}

	ngOnInit() {
		this.spinner.show();
		
		const storedLangCode = localStorage.getItem('curentLang');
		const initialLangCodeIsValid = this.languages.some(lang => lang.code === storedLangCode);
		
		const initialLangCode: LanguageSetting['code'] = initialLangCodeIsValid
			? storedLangCode as LanguageSetting['code']
			: 'en';
			
		this.applyLanguageSettings(initialLangCode);
		
		this.translate.onLangChange.subscribe((event) => {
			this.curentLang = event.lang;
		});

		this.curentLang = this.translate.currentLang || this.translate.defaultLang || 'en';
		
		setTimeout(() => {
			this.spinner.hide();
		}, 500);
		
		window.scrollTo(0, 0);
	}
	
	/**
	 * Handles the language change (simplified for public page)
	 * @param langCode The code of the language to switch to
	 */
	public changeLang(langCode: LanguageSetting['code']): void {
		if (this.selectedLanguage.code === langCode) {
			return;
		}

		this.applyLanguageSettings(langCode);
		
		setTimeout(() => {
			window.scrollTo(0, 0);
		}, 100);
	}
	
	/**
	 * Applies language changes to the client side
	 * @param langCode The code of the language to apply
	 */
	private applyLanguageSettings(langCode: LanguageSetting['code']): void {
		this.languageService.apply(langCode, { refreshRoute: false });

		const newSelectedLanguage = this.languages.find(language => language.code === langCode);
		if (newSelectedLanguage) {
			this.selectedLanguage = newSelectedLanguage;
		}

		this.curentLang = langCode;
		this.landingLang = normalizeThiLang(langCode);
	}
}
